/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_9Inputs */



/**
* | output |
* | --- |
* | "Bottom right" |
*
* @param {Live_Caption_Youtube_Region_9Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_9 = /** @type {((inputs?: Live_Caption_Youtube_Region_9Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_9Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En bas à droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unten rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("In basso o")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Внизу справа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abajo a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("右下角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右下")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नीचे दाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Canto inferior direito")
	return /** @type {LocalizedString} */ ("Bottom right")
});